<div class="minclt-container-sidebar">
  <div class="relative">
    <div class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <div class="sidebar-menu">
        <ng-content select="[menu-sidebar]"></ng-content>
      </div>
      <p-button styleClass="sidebar-btn" icon="pi pi-bars" (onClick)="onSidebarToggle()" />
    </div>
  </div>
  <main class="content relative" [style.background-color]="bgcolor">
    <div class="content-inner">
      <ng-content select="[content-sidebar]"></ng-content>
    </div>
  </main>
</div>